import {useContext, useEffect, useState} from 'react'
import {ModalServices} from './ModalServices'
import {FilterContext} from '../../context/FilterContext'
import {APiUrbit} from '../../../../services/api/apiUrbit'
import {formatDistancia, formatNumber} from '../../../explorer/components/common'
import {DataContext} from '../../context/DataContext'
import {BiInfoCircle} from 'react-icons/bi'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import SwitchSituationComponent from '../../../../components/UI/Switchs/SituationSwitch'

type props = {
  onChange: any
}
const api = new APiUrbit()

type Props = {
  info: any
  servico: string
  distancia: number
  nome: string
  resultado: any
  showOnMap?: boolean
  tipo?: string
  key?: string
  format?: (data: any) => any
}[]

export default function CheckServicesInfra({onChange}: props) {
  const [resultado, setResultado] = useState<Props>()
  const {endereco, filter} = useContext(FilterContext)
  const {cacheResult, setCacheResult} = useContext(DataContext)

  // let geom = geometria
  // const jsonEncoded = btoa(unescape(encodeURIComponent(JSON.stringify(geom))))

  useEffect(() => {
    async function loadservice() {
      const servicos = [
        {
          servico: 'area-vulnerabilidade',
          distancia: 500,
          nome: 'Area de Vulnerabilidade',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'comunidades ou assentamentos precários segundo IBGE ou/e Prefeitura',
        },
        {
          servico: 'metro',
          distancia: 1000,
          nome: 'Metrô',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Metrô em 1km',
        },
        {
          servico: 'trem',
          distancia: 1000,
          nome: 'Trem',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Trem em 1km',
        },
        {
          servico: 'metro-planejado',
          distancia: 1000,
          nome: 'Metrô planejado',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Estações planejadas de metrô, VLT ou monotrilho',
        },
        {
          servico: 'equipamentos-educacao',
          distancia: 500,
          nome: 'Equipamentos de Educaçaõ',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Equipamentos de Educação em 1km',
        },
        {
          servico: 'area-alagamento',
          distancia: 500,
          nome: 'Área de alagamento',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Áreas inundáveis ou Pontos de Alagamentos',
        },
        {
          servico: 'risco-geologico',
          distancia: 500,
          nome: 'Risco Geoloógico',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Áreas de risco geológico',
        },
        {
          servico: 'shopping',
          distancia: 500,
          nome: 'Shopping',
          resultado: null,
          showOnMap: false,
          tipo: 'qtde',
          info: 'Shopping Centers',
        },
      ]
      let servicosCarregado = []
      // eslint-disable-next-line array-callback-return
      servicos.forEach(async (item, index) => {
        let url = `service/${item.servico}/${endereco.longitude}/${endereco.latitude}?distance=${item.distancia}`
        // &intersect=${jsonEncoded}`
        let result = await api.get(url)

        item.resultado = result
        servicosCarregado.push(item)
      })
      cacheResult['servicosInfraestrtutura'] = servicos
      setResultado(servicos)
      setCacheResult(cacheResult)

      return servicos
    }
    loadservice()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, endereco])

  const link = '#'
  const Link = ({id, children, title}) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a href={link}>{children}</a>
    </OverlayTrigger>
  )
  return (
    <table className='table table-row-dashed table-row-gray-300 gy-2'>
      <thead>
        <tr className='fw-bolder fs-6 text-gray-800'>
          <th>Indicador</th>
          <th className='text-center'>Valor/Qtde</th>
          <th className='text-center'>Lista </th>
          <th className='text-center'>Exibir no mapa </th>
        </tr>
      </thead>
      <tbody>
        {resultado ? (
          resultado.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <Link id={index} title={item.info}>
                    <BiInfoCircle className='fs-1 me-2'></BiInfoCircle>
                  </Link>
                  {item.nome} ({formatDistancia(item.distancia)})
                </td>
                <td className='w-80px text-center'>
                  {item.resultado ? (
                    (item.resultado.itens || []).length > 0 ? (
                      item.tipo === 'qtde' ? (
                        <span className=' text-right fs-semibold'>{item.resultado.total}</span>
                      ) : (
                        <span className=' text-right fs-semibold'>
                          {item.format(item.resultado.itens[0][item.key])}
                        </span>
                      )
                    ) : (
                      <span className='badge badge-warning'>Não</span>
                    )
                  ) : null}
                </td>
                <td className='text-center'>
                  {item.resultado ? (
                    item.tipo === 'qtde' && (item.resultado.itens || []).length > 0 ? (
                      <ModalServices list={item.resultado.itens}></ModalServices>
                    ) : null
                  ) : null}
                </td>
                <td className='text-center'>
                  {item?.resultado?.itens.length > 0 ? (
                    <SwitchSituationComponent
                      onChange={(value) => {
                        setResultado((prev) => {
                          if (!prev) {
                            return prev
                          }
                          const updated = prev.map((row, rowIndex) => {
                            if (rowIndex !== index) {
                              return row
                            }
                            return {...row, showOnMap: value}
                          })
                          setCacheResult({...cacheResult, servicosInfraestrtutura: updated})
                          if (onChange) {
                            onChange(updated)
                          }
                          return updated
                        })
                      }}
                      situation={!!item.showOnMap}
                    ></SwitchSituationComponent>
                  ) : (
                    <span>--</span>
                  )}
                </td>
              </tr>
            )
          })
        ) : (
          <tr>
            <td className='text-center' colSpan={2}>
              {' '}
              <div>Carregando</div>{' '}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
